import { filter, take } from 'rxjs/operators';
import { ImpressionSource } from 'src/app/@utils/gtm-tracking/events';
import { isDefined } from 'src/app/@utils/is-defined';

import { Directive, ElementRef, Input, OnInit } from '@angular/core';
import { GtmService } from '@core/services/gtm/gtm.service';
import { IntersectionService } from '@core/services/intersection.service';
import { ProductSearchViewModel } from '@models/api-search.models';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

const impressionInviewKey = 'impressionInView';

@UntilDestroy()
@Directive({
    selector: '[appImpressionTracking]',
    standalone: true
})
export class ImpressionTrackingDirective implements OnInit {
    @Input()
    private readonly appImpressionTracking: ProductSearchViewModel;

    @Input()
    private readonly impressionSource: ImpressionSource;

    @Input()
    private readonly index?: number;

    constructor(
        private intersectionService: IntersectionService,
        private element: ElementRef,
        private gtmService: GtmService
    ) {}

    ngOnInit(): void {
        if (!this.appImpressionTracking) {
            console.warn(`missing product model, got: ${this.appImpressionTracking}`);
            return;
        }

        const index = isDefined<number>(this.index) ? { index: this.index } : {};

        this.intersectionService
            .observe(impressionInviewKey, this.element.nativeElement)
            .pipe(
                untilDestroyed(this),
                filter(entry => entry.target === this.element.nativeElement && entry.isIntersecting),
                take(1)
            )
            .subscribe(() => {
                this.gtmService.addToImpressionQueue(
                    { ...this.appImpressionTracking, ...index },
                    this.impressionSource
                );
            });
    }
}
